/**
 * @file 税計算モジュール
 * @namespace ddv2.library
 */

/**
 * @module tax
 */

import fraction from '@/ddv2.library/fraction.js'
import store from '@/store'

export default {
  /**
   * 税抜き金額から消費税金額を算出
   * @param {Num} money 税抜き金額
   * @param {String} hasuKbn 端数区分
   * @param {String} date 対象日付
   * @returns {Num} 消費税額
   * @example
   * const a = tax.calcTax(someMoney, hasuKbn)
   */
  calcTax: function (money, hasuKbn, date) {
    if (typeof money === 'string') {
      if (money === '') { return '' }
      money = parseFloat(money.replaceAll(',', ''))
    }
    var taxPer = this.getTax(date)
    return fraction.calcFraction(money * taxPer / 100, hasuKbn)
  },
  /**
   * 税抜き金額から税込み金額を算出
   * @param {Num} money 税抜き金額
   * @param {String} hasuKbn 端数区分
   * @param {String} date 対象日付
   * @returns {Num} 税込み金額
   * @example
   * const a = tax.calcTaxToIncluded(someMoney, hasuKbn)
   */
  calcTaxToIncluded: function (money, hasuKbn, date) {
    if (typeof money === 'string') {
      if (money === '') { return '' }
      money = parseFloat(money.replaceAll(',', ''))
    }
    return money + this.calcTax(money, hasuKbn, date)
  },
  /**
   * 税込み金額から消費税金額を算出
   * @param {Num} money 税込み金額
   * @param {String} hasuKbn 端数区分
   * @param {String} date 対象日付
   * @returns {Num} 消費税額
   * @example
   * const a = tax.calcTaxFromIncluded(someMoney, hasuKbn)
   */
  calcTaxFromIncluded: function (money, hasuKbn, date) {
    if (typeof money === 'string') {
      if (money === '') { return '' }
      money = parseFloat(money.replaceAll(',', ''))
    }
    var taxPer = this.getTax(date)
    return fraction.calcFraction(money * taxPer / (100 + taxPer), hasuKbn)
  },
  /**
   * 税込み金額から税抜き金額を算出
   * @param {Num} money 税込み金額
   * @param {String} hasuKbn 端数区分
   * @param {String} date 対象日付
   * @returns {Num} 税抜き金額
   * @example
   * const a = tax.calcWithoutTax(someMoney, hasuKbn)
   */
  calcWithoutTax: function (money, hasuKbn, date) {
    if (typeof money === 'string') {
      if (money === '') { return '' }
      money = parseFloat(money.replaceAll(',', ''))
    }
    return money - this.calcTaxFromIncluded(money, hasuKbn, date)
  },
  /**
   * 税込み金額から税抜き金額を算出（直計算）
   * @param {Num} money 税込み金額
   * @param {String} hasuKbn 端数区分
   * @param {String} date 対象日付
   * @returns {Num} 税抜き金額
   * @example
   * const a = tax.calcWithoutTaxDirect(someMoney, hasuKbn)
   */
  calcWithoutTaxDirect: function (money, hasuKbn, date) {
    if (typeof money === 'string') {
      if (money === '') { return '' }
      money = parseFloat(money.replaceAll(',', ''))
    }
    var taxPer = this.getTax(date)
    return fraction.calcFraction(money / ((100 + taxPer) / 100), hasuKbn, date)
  },
  /**
 * 税込み金額から税抜き金額を五捨六入で算出
 * @param {Num} money 税込み金額
 * @param {String} date 対象日付
 * @returns {Num} 税抜き金額
 * @example
 * const a = tax.calcWithoutTax5u6d(someMoney, hasuKbn)
 */
  calcWithoutTax5u6d: function (money, date) {
    if (typeof money === 'string') {
      if (money === '') { return '' }
      money = parseFloat(money.replaceAll(',', ''))
    }
    var taxPer = this.getTax(date)
    if (money === 0) {
      return 0
    } else {
      return Math.round(money / ((100 + taxPer) / 100) - 0.1)
    }
    // return fraction.calcFraction(money / ((100 + taxPer) / 100), hasuKbn, date)
  },
  /**
   * 日付から消費税率を取得
   * @param {String} date 対象日付
   * @returns {Num} 消費税率
   * @example
   * const a = tax.calcWithoutTax(someMoney, hasuKbn)
   */
  getTax: function (date) {
    const taxList = store.state.DDMasters.msystax

    const taxData = taxList.find((m) => {
      var targetDate = new Date(date)
      var startDate = new Date(m.tekiyoStartYmd.substr(0, 10))
      var endDate = new Date(m.tekiyoEndYmd.substr(0, 10))
      return startDate <= targetDate && targetDate <= endDate
    })
    if (taxData === undefined) {
      console.error(`消費税マスタが存在しません。日付:${date}`)
      return null
    }
    return taxData.taxPer
  }
}
